import { useContext } from "react";

import { GeometrySelectionContext } from "../../components/context";

export const useGeometrySelectionContext = () => {
  return useContext(GeometrySelectionContext);
};
